import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import './SubmissionSuccess.css';

const SubmissionSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const [copied, setCopied] = React.useState(false);
  const [isEditing, setIsEditing] = React.useState(false);
  const [editableText, setEditableText] = React.useState(state.requirements || '');
  const [isSending, setIsSending] = React.useState(false);
const [sendSuccess, setSendSuccess] = React.useState(null);


  const handleCopy = () => {
    const text = state.requirements;
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };
  
  
  
  const handleEdit = () => {
    if (isEditing) {
      setIsEditing(false);
    } else {
      setIsEditing(true);
    }
  };
  
  

  if (!state || !state.requirements) {
    return (
      <div className="submission-error">
        <h2>Oops! No project data found.</h2>
        <button onClick={() => navigate('/')}>Go back home</button>
      </div>
    );
  }
  const handleSendQuotation = async () => {
    setIsSending(true);
    setSendSuccess(null);
  
    try {
      const response = await fetch('https://api-uifytpudeq-uc.a.run.app/send-quotation', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: state.email,
          prompt: state.originalPrompt || 'Client project prompt',
          requirements: editableText,
        }),
      });
  
      if (!response.ok) throw new Error('Failed to send');
  
      setSendSuccess(true);
    } catch (err) {
      console.error(err);
      setSendSuccess(false);
    } finally {
      setIsSending(false);
    }
  };

  return (
    <>
      <Navbar />
      <div className="submission-success">
        <h1>Your Quotation Is Ready!</h1>
        <p>
          You can review, edit, and finalize your project quotation below. When you're ready, click "Send Quotation" to receive a copy by email and notify our team.
        </p>
        <div className="requirements-box">
            <div className="requirements-toolbar">
              <button className="copy-button" onClick={handleCopy}>
                {copied ? (
                    <>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                        <path d="M20 6L9 17l-5-5" stroke="#00d084" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    Copied
                    </>
                ) : (
                    <>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                        <path d="M9 9H5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-4" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M16 3h5v5" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M21 3l-9 9" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    Copy
                    </>
                )}
              </button>
              <button className="edit-button" onClick={handleEdit}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path d="M12 20h9" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                {isEditing ? 'Save' : 'Edit'}
              </button>

            </div>
          <h2>Generated Requirements</h2>
            {isEditing ? (
  <textarea
    className="requirements-textarea"
    value={editableText}
    onChange={(e) => setEditableText(e.target.value)}
    rows={20}
  />
) : (
<div
  className="requirements-content"
  dangerouslySetInnerHTML={{
    __html: editableText
      .replace(/^## (.*)$/gm, '<h3 class="quote-heading">$1</h3>')
      .replace(/\n/g, '<br/>'),
  }}
/>

)}

        </div>
        <div className='button-container'>
        <button className="send-button" onClick={handleSendQuotation} disabled={isSending || sendSuccess}>
  {isSending ? 'Sending...' : sendSuccess ? 'Sent ✔' : 'Send Quotation'}
</button>
{sendSuccess === false && <p className="error-message">Failed to send. Try again.</p>}
</div>
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default SubmissionSuccess;
